const ACTIVITY_PRESENTATION = Object.freeze({
  basketball: Object.freeze({ icon: '🏀', title: 'Basketball' }),
  baseball: Object.freeze({ icon: '⚾', title: 'Baseball' }),
  boxing: Object.freeze({ icon: '🥊', title: 'Boxing' }),
  football: Object.freeze({ icon: '🏈', title: 'Football' }),
  paintball: Object.freeze({ icon: '🎨', title: 'Paintball' }),
  soccer: Object.freeze({ icon: '⚽', title: 'Soccer' }),
})

const FOUNDATION_PLAY_MODES = Object.freeze([
  Object.freeze({ id: 'socialLobbies', label: 'Public lobbies' }),
  Object.freeze({ id: 'privateLobbies', label: 'Your private servers' }),
])

const FOUNDATION_ROUTES = new Set([
  '/menu',
  '/courts',
  '/avatar',
  '/store',
  '/challenges',
  '/people',
  '/profile/[targetDeviceId]',
  '/gcMobile',
  '/gcPro',
  '/hologramAvatar',
  '/worldPass',
  '/team',
  '/seasonPass',
])

function getFoundationShellPage(destination = {}) {
  if (destination.kind === 'activity') {
    const activity = ACTIVITY_PRESENTATION[destination.activity]

    if (activity) {
      return {
        compact: true,
        icon: activity.icon,
        showBack: true,
        title: activity.title,
      }
    }
  }

  if (destination.kind === 'worlds') {
    return {
      compact: true,
      icon: '🌐',
      showBack: true,
      title: 'Worlds',
    }
  }

  return {
    compact: false,
    icon: null,
    showBack: false,
    title: 'Home',
  }
}

function getFoundationRoutePage(routeId) {
  if (routeId === 'nbaTeams') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'NBA Teams',
    }
  }

  if (routeId === 'mlbTeams') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'MLB Teams',
    }
  }

  if (routeId === 'seasonPass') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Season Pass',
    }
  }

  if (routeId === 'store') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Shop',
    }
  }

  if (routeId === 'avatar') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Style',
    }
  }

  if (routeId === 'challenges') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Missions',
    }
  }

  if (routeId === 'people') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Social',
    }
  }

  if (routeId === 'profile') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Profile',
    }
  }

  if (routeId === 'gcMobile') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'GC Mobile',
    }
  }

  if (routeId === 'gcPro') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'GC Pro',
    }
  }

  if (routeId === 'hologramAvatar') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'Hologram Avatar',
    }
  }

  if (routeId === 'worldPass') {
    return {
      compact: true,
      icon: null,
      showBack: true,
      title: 'World Pass',
    }
  }

  return getFoundationShellPage()
}

function resolveFoundationTeamType(isRouterReady, teamType) {
  if (!isRouterReady) return null

  return teamType === 'mlb' ? 'mlb' : 'nba'
}

function normalizeFoundationPlayMode(mode) {
  return mode === 'privateLobbies' ? 'privateLobbies' : 'socialLobbies'
}

function normalizeFoundationSocialTab(tab) {
  return tab === 'creators' ? 'creators' : 'discover'
}

function shouldAnimatePageEntry(route, transitionRequested) {
  return Boolean(transitionRequested) && !FOUNDATION_ROUTES.has(route)
}

module.exports = {
  ACTIVITY_PRESENTATION,
  FOUNDATION_PLAY_MODES,
  getFoundationRoutePage,
  getFoundationShellPage,
  normalizeFoundationPlayMode,
  normalizeFoundationSocialTab,
  resolveFoundationTeamType,
  shouldAnimatePageEntry,
}
